import styled from "styled-components"

export const StyledOfferItemsSection = styled.section`
  width: 100%;
  overflow: hidden;
`
